import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import {
  WorkforceResourcesCrews,
  WorkforceResourcesSupervisors,
} from '@/modules/home';
import { IHome } from '@/modules/home/types';

const TAB_QUERY_INDICATOR = 'resources';

const WorkforceResourcesTabs = () => {
  const { query } = useRouter();
  const [selectedTab, setSelectedTab] = useState<
    IHome.IWorkforceResourcesStatusValues | undefined
  >(undefined);

  useEffect(() => {
    setSelectedTab(
      query[TAB_QUERY_INDICATOR] as
        | IHome.IWorkforceResourcesStatusValues
        | undefined
    );
  }, [query]);

  return (
    <>
      {selectedTab === 'supervisors' && <WorkforceResourcesSupervisors />}
      {selectedTab === 'crews' && <WorkforceResourcesCrews />}
    </>
  );
};

export { WorkforceResourcesTabs };
